/* Generated by ai2react v0.102.0 - 2021-09-14 04:06 */
/* ai file: 08-the-latam.ai */

import { makeAi2React } from './src/index'
import img0 from './img/08-the-latam-large.svg'
import img1 from './img/08-the-latam-mobile.svg'

const styles = `
  #g-08-the-latam-box ,
  #g-08-the-latam-box .g-artboard {
    margin:0 auto;
  }
  #g-08-the-latam-box p {
    margin:0;
  }
  #g-08-the-latam-box .g-aiAbs {
    position:absolute;
  }
  #g-08-the-latam-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-08-the-latam-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-08-the-latam-box .g-aiPointText p { white-space: nowrap; }
  #g-08-the-latam-large {
    position:relative;
    overflow:hidden;
  }
  #g-08-the-latam-large p {
    font-family:Inter;
    font-weight:400;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-08-the-latam-large .g-pstyle0 {
    font-weight:800;
    line-height:23px;
    height:23px;
    letter-spacing:-0.02em;
    font-size:19px;
  }
  #g-08-the-latam-large .g-pstyle1 {
    font-weight:700;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    color:rgb(101,54,148);
  }
  #g-08-the-latam-large .g-pstyle2 {
    font-weight:700;
    line-height:12px;
    height:12px;
    letter-spacing:-0.02em;
    font-size:10px;
  }
  #g-08-the-latam-large .g-pstyle3 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-08-the-latam-large .g-pstyle4 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-08-the-latam-large .g-pstyle5 {
    height:13px;
  }
  #g-08-the-latam-large .g-pstyle6 {
    line-height:12px;
    height:12px;
    font-size:10px;
  }
  #g-08-the-latam-large .g-pstyle7 {
    line-height:12px;
    height:12px;
    font-size:10px;
    color:rgb(88,89,91);
  }
  #g-08-the-latam-large .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
    color:rgb(255,255,255);
  }
  #g-08-the-latam-large .g-pstyle9 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.03em;
    font-size:10px;
  }
  #g-08-the-latam-large .g-pstyle10 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-08-the-latam-large .g-pstyle11 {
    line-height:14px;
    height:14px;
  }
  #g-08-the-latam-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-08-the-latam-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-08-the-latam-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-08-the-latam-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-08-the-latam-large .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-08-the-latam-large .g-cstyle5 {
    letter-spacing:-0.04em;
  }
  #g-08-the-latam-large .g-cstyle6 {
    letter-spacing:-0.033em;
  }
  #g-08-the-latam-large .g-cstyle7 {
    letter-spacing:-0.029em;
  }
  #g-08-the-latam-large .g-cstyle8 {
    letter-spacing:-0.086em;
  }
  #g-08-the-latam-large .g-cstyle9 {
    letter-spacing:-0.036em;
  }
  #g-08-the-latam-large .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-08-the-latam-large .g-cstyle11 {
    letter-spacing:-0.034em;
  }
  #g-08-the-latam-large .g-cstyle12 {
    letter-spacing:-0.039em;
  }
  #g-08-the-latam-large .g-cstyle13 {
    letter-spacing:-0.041em;
  }
  #g-08-the-latam-large .g-cstyle14 {
    letter-spacing:-0.043em;
  }
  #g-08-the-latam-large .g-cstyle15 {
    letter-spacing:-0.044em;
  }
  #g-08-the-latam-large .g-cstyle16 {
    letter-spacing:-0.035em;
  }
  #g-08-the-latam-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-08-the-latam-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-08-the-latam-mobile .g-pstyle0 {
    font-weight:800;
    line-height:31px;
    height:31px;
    letter-spacing:-0.02em;
    font-size:26px;
  }
  #g-08-the-latam-mobile .g-pstyle1 {
    font-weight:700;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    color:rgb(101,54,148);
  }
  #g-08-the-latam-mobile .g-pstyle2 {
    font-weight:700;
    line-height:12px;
    height:12px;
    letter-spacing:-0.02em;
    font-size:10px;
  }
  #g-08-the-latam-mobile .g-pstyle3 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-08-the-latam-mobile .g-pstyle4 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-08-the-latam-mobile .g-pstyle5 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-08-the-latam-mobile .g-pstyle6 {
    height:13px;
  }
  #g-08-the-latam-mobile .g-pstyle7 {
    line-height:12px;
    height:12px;
    font-size:10px;
  }
  #g-08-the-latam-mobile .g-pstyle8 {
    line-height:12px;
    height:12px;
    font-size:10px;
    color:rgb(88,89,91);
  }
  #g-08-the-latam-mobile .g-pstyle9 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
    color:rgb(255,255,255);
  }
  #g-08-the-latam-mobile .g-pstyle10 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.03em;
    font-size:10px;
  }
  #g-08-the-latam-mobile .g-pstyle11 {
    line-height:14px;
    height:14px;
  }
  #g-08-the-latam-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-08-the-latam-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-08-the-latam-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-08-the-latam-mobile .g-cstyle3 {
    letter-spacing:-0.029em;
  }
  #g-08-the-latam-mobile .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-08-the-latam-mobile .g-cstyle5 {
    letter-spacing:-0.03em;
  }
  #g-08-the-latam-mobile .g-cstyle6 {
    letter-spacing:-0.04em;
  }
  #g-08-the-latam-mobile .g-cstyle7 {
    letter-spacing:-0.033em;
  }
  #g-08-the-latam-mobile .g-cstyle8 {
    letter-spacing:-0.086em;
  }
  #g-08-the-latam-mobile .g-cstyle9 {
    letter-spacing:-0.036em;
  }
  #g-08-the-latam-mobile .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-08-the-latam-mobile .g-cstyle11 {
    letter-spacing:-0.034em;
  }
  #g-08-the-latam-mobile .g-cstyle12 {
    letter-spacing:-0.039em;
  }
  #g-08-the-latam-mobile .g-cstyle13 {
    letter-spacing:-0.041em;
  }
  #g-08-the-latam-mobile .g-cstyle14 {
    letter-spacing:-0.043em;
  }
  #g-08-the-latam-mobile .g-cstyle15 {
    letter-spacing:-0.044em;
  }
  #g-08-the-latam-mobile .g-cstyle16 {
    letter-spacing:-0.035em;
  }

`

const html = props => `
<div id="g-08-the-latam-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-08-the-latam-large" class="g-artboard" style="width:800px; height:501px;" data-aspect-ratio="1.597" data-min-width="800">
<div style=""></div>
    <img id="g-08-the-latam-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.6553%;margin-top:-13.3px;left:0.5092%;width:88px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.4407%;margin-top:-8.3px;left:7.726%;width:80px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.39%;margin-top:-7px;left:1.1055%;width:70px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.2394%;margin-top:-6.3px;left:49.8525%;width:40px;">
      <p class="g-pstyle3">P<span class="g-cstyle0">a</span>í<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.2394%;margin-top:-6.3px;left:77.634%;width:56px;">
      <p class="g-pstyle4">Pun<span class="g-cstyle2">ta</span>je<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.386%;margin-top:-7px;left:1.1055%;width:69px;">
      <p class="g-pstyle2">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.4493%;margin-top:-7.4px;left:9.5148%;width:210px;">
      <p class="g-pstyle5">Po<span class="g-cstyle3">n</span>ti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">i</span>a <span class="g-cstyle4">U</span><span class="g-cstyle3">ni</span>v<span class="g-cstyle3">e</span>r<span class="g-cstyle3">sid</span>a<span class="g-cstyle3">d</span> C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span> Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.7732%;margin-top:-7px;left:49.1208%;width:47px;">
      <p class="g-pstyle6">C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.7732%;margin-top:-7px;left:60.6756%;width:45px;">
      <p class="g-pstyle7">9<span class="g-cstyle5">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6227%;margin-top:-6.3px;left:3.8518%;width:28px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0341%;margin-top:-7.4px;left:9.5148%;width:146px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">de </span>São Paulo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.358%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.358%;margin-top:-7px;left:60.7844%;width:44px;">
      <p class="g-pstyle7">8<span class="g-cstyle8">7</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.2075%;margin-top:-6.3px;left:3.825%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.6189%;margin-top:-7.4px;left:9.5148%;width:146px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">de </span>C<span class="g-cstyle3">a</span>mpina<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.9429%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.9429%;margin-top:-7px;left:60.6855%;width:45px;">
      <p class="g-pstyle7">86<span class="g-cstyle3">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.7923%;margin-top:-6.3px;left:3.825%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.2038%;margin-top:-7.4px;left:9.5148%;width:190px;">
      <p class="g-pstyle5">I<span class="g-cstyle3">n</span>st<span class="g-cstyle3">it</span>uto <span class="g-cstyle10">T</span>e<span class="g-cstyle3">c</span>no<span class="g-cstyle3">l</span>ó<span class="g-cstyle3">gi</span>co d<span class="g-cstyle3">e</span> <span class="g-cstyle3">M</span>ont<span class="g-cstyle3">e</span>r<span class="g-cstyle6">r</span>e<span class="g-cstyle3">y</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.7273%;margin-top:-7px;left:49.1208%;width:57px;">
      <p class="g-pstyle6"><span class="g-cstyle3">M</span>éx<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.7273%;margin-top:-7px;left:60.7313%;width:45px;">
      <p class="g-pstyle7">8<span class="g-cstyle11">3</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.5768%;margin-top:-6.3px;left:3.8073%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:46.9882%;margin-top:-7.4px;left:9.5148%;width:198px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">de</span>r<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> <span class="g-cstyle3">M</span>i<span class="g-cstyle3">n</span>as G<span class="g-cstyle3">er</span>a<span class="g-cstyle3">is</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.3121%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle6">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.3121%;margin-top:-7px;left:60.6768%;width:45px;">
      <p class="g-pstyle7">8<span class="g-cstyle3">2</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.1616%;margin-top:-6.3px;left:3.834%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.573%;margin-top:-7.4px;left:9.5148%;width:123px;">
      <p class="g-pstyle10"><span class="g-cstyle6">U</span><span class="g-cstyle7">n</span>iv<span class="g-cstyle7">e</span>r<span class="g-cstyle7">s</span>i<span class="g-cstyle7">d</span>ad<span class="g-cstyle7"> </span>de <span class="g-cstyle7">C</span>h<span class="g-cstyle7">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.8969%;margin-top:-7px;left:49.1208%;width:47px;">
      <p class="g-pstyle6">C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.8969%;margin-top:-7px;left:60.7485%;width:43px;">
      <p class="g-pstyle7">8<span class="g-cstyle3">2</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.7464%;margin-top:-6.3px;left:3.834%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.1579%;margin-top:-7.4px;left:9.5148%;width:253px;">
      <p class="g-pstyle5">Po<span class="g-cstyle3">n</span>ti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">i</span>a <span class="g-cstyle4">U</span><span class="g-cstyle3">ni</span>v<span class="g-cstyle3">e</span>r<span class="g-cstyle3">sid</span>a<span class="g-cstyle3">d</span> C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">ic</span>a d<span class="g-cstyle3">e</span> R<span class="g-cstyle3">í</span>o <span class="g-cstyle3">de </span>Ja<span class="g-cstyle3">n</span>e<span class="g-cstyle3">i</span><span class="g-cstyle6">r</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.4818%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.4818%;margin-top:-7px;left:60.7573%;width:43px;">
      <p class="g-pstyle7">81,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.3312%;margin-top:-6.3px;left:3.8429%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.7427%;margin-top:-7.4px;left:9.5148%;width:225px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">de</span>r<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> R<span class="g-cstyle3">ío</span> <span class="g-cstyle3">G</span>r<span class="g-cstyle3">a</span>n<span class="g-cstyle3">d</span>e d<span class="g-cstyle3">el</span> Su<span class="g-cstyle3">r</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.2662%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.2662%;margin-top:-7px;left:60.6398%;width:45px;">
      <p class="g-pstyle7">8<span class="g-cstyle12">0</span><span class="g-cstyle13">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.1157%;margin-top:-6.3px;left:3.8161%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.5271%;margin-top:-7.4px;left:9.5148%;width:184px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">de</span>r<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> S<span class="g-cstyle3">ã</span>o Paul<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.851%;margin-top:-7px;left:49.1208%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.851%;margin-top:-7px;left:60.7115%;width:44px;">
      <p class="g-pstyle7">8<span class="g-cstyle12">0</span><span class="g-cstyle14">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.7005%;margin-top:-6.3px;left:3.8161%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.1119%;margin-top:-7.4px;left:9.5148%;width:201px;">
      <p class="g-pstyle5"><span class="g-cstyle6">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">ad</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">de</span>r<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> R<span class="g-cstyle3">ío</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Jan<span class="g-cstyle3">ei</span><span class="g-cstyle4">r</span><span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.4359%;margin-top:-7px;left:49.1208%;width:46px;">
      <p class="g-pstyle9"><span class="g-cstyle7">B</span>ra<span class="g-cstyle7">s</span>i<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.4359%;margin-top:-7px;left:60.6756%;width:42px;">
      <p class="g-pstyle7">8<span class="g-cstyle12">0</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.2853%;margin-top:-6.3px;left:3.5095%;width:32px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:92.8719%;margin-top:-8.3px;left:0.5995%;width:248px;">
      <p class="g-pstyle11">(*) <span class="g-cstyle11">F</span>u<span class="g-cstyle3">en</span>te: ww<span class="g-cstyle15">w</span><span class="g-cstyle16">.</span>t<span class="g-cstyle3">i</span>mesh<span class="g-cstyle3">i</span>gh<span class="g-cstyle3">e</span><span class="g-cstyle4">r</span>e<span class="g-cstyle3">d</span>uc<span class="g-cstyle6">a</span>t<span class="g-cstyle3">i</span>o<span class="g-cstyle3">n.co</span>m<span class="g-cstyle1"> </span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-08-the-latam-mobile" class="g-artboard" style="max-width: 320px;max-height: 502px" data-aspect-ratio="0.637" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 156.875% 0;"></div>
    <img id="g-08-the-latam-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.9032%;margin-top:-17.6px;left:1.2729%;width:110px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.2207%;margin-top:-8.3px;left:17.7524%;width:80px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.1701%;margin-top:-7px;left:1.2013%;width:70px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.0198%;margin-top:-6.3px;left:49.9437%;width:40px;">
      <p class="g-pstyle3">P<span class="g-cstyle0">a</span>í<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.0198%;margin-top:-6.3px;left:69.0851%;width:56px;">
      <p class="g-pstyle4">Pun<span class="g-cstyle2">ta</span>je<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1621%;margin-top:-7px;left:0.8888%;width:69px;">
      <p class="g-pstyle2">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.0881%;margin-top:-13.8px;left:7.5369%;width:127px;">
      <p class="g-pstyle5"><span class="g-cstyle3">Po</span>n<span class="g-cstyle3">ti</span>fi<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a </span><span class="g-cstyle4">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">r</span>sid<span class="g-cstyle3">a</span>d<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle6">C<span class="g-cstyle4">a</span>t<span class="g-cstyle5">ó</span>l<span class="g-cstyle5">ic</span>a d<span class="g-cstyle5">e</span> Chi<span class="g-cstyle5">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.5366%;margin-top:-7px;left:58.1145%;width:47px;">
      <p class="g-pstyle7">C<span class="g-cstyle5">h</span>i<span class="g-cstyle5">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.5366%;margin-top:-7px;left:69.189%;width:45px;">
      <p class="g-pstyle8">9<span class="g-cstyle6">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.3864%;margin-top:-6.3px;left:3.3795%;width:28px;">
      <p class="g-pstyle9"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.6579%;margin-top:-13.8px;left:7.5369%;width:87px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle6"><span class="g-cstyle5">de </span>São Paulo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1063%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle3">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1063%;margin-top:-7px;left:69.4609%;width:44px;">
      <p class="g-pstyle8">8<span class="g-cstyle8">7</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.9561%;margin-top:-6.3px;left:3.3125%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.0284%;margin-top:-13.8px;left:7.5369%;width:87px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle6"><span class="g-cstyle5">de </span>C<span class="g-cstyle5">a</span>mpina<span class="g-cstyle5">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.676%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle3">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.676%;margin-top:-7px;left:69.2137%;width:45px;">
      <p class="g-pstyle8">86<span class="g-cstyle5">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.5258%;margin-top:-6.3px;left:3.3125%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.5981%;margin-top:-13.8px;left:7.5369%;width:120px;">
      <p class="g-pstyle6">I<span class="g-cstyle5">n</span>st<span class="g-cstyle5">it</span>uto <span class="g-cstyle10">T</span>e<span class="g-cstyle5">c</span>no<span class="g-cstyle5">l</span>ó<span class="g-cstyle5">gi</span>co</p>
      <p class="g-pstyle6">d<span class="g-cstyle5">e</span> <span class="g-cstyle5">M</span>ont<span class="g-cstyle5">e</span>r<span class="g-cstyle7">r</span>e<span class="g-cstyle5">y</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.445%;margin-top:-7px;left:58.1145%;width:57px;">
      <p class="g-pstyle7"><span class="g-cstyle5">M</span>éx<span class="g-cstyle5">i</span>c<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.445%;margin-top:-7px;left:69.3282%;width:45px;">
      <p class="g-pstyle8">8<span class="g-cstyle11">3</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.2947%;margin-top:-6.3px;left:3.2681%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.5662%;margin-top:-13.8px;left:7.5369%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span>F<span class="g-cstyle3">e</span>de<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l</span></p>
      <p class="g-pstyle6">d<span class="g-cstyle5">e</span> <span class="g-cstyle5">M</span>i<span class="g-cstyle5">n</span>as G<span class="g-cstyle5">er</span>a<span class="g-cstyle5">is</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.0147%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle7">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.0147%;margin-top:-7px;left:69.192%;width:45px;">
      <p class="g-pstyle8">8<span class="g-cstyle5">2</span><span class="g-cstyle9">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8645%;margin-top:-6.3px;left:3.3351%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.136%;margin-top:-13.8px;left:7.5369%;width:81px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle6"><span class="g-cstyle5">de </span>C<span class="g-cstyle5">h</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.5844%;margin-top:-7px;left:58.1145%;width:47px;">
      <p class="g-pstyle7">C<span class="g-cstyle5">h</span>i<span class="g-cstyle5">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.5844%;margin-top:-7px;left:69.3712%;width:43px;">
      <p class="g-pstyle8">8<span class="g-cstyle5">2</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.4342%;margin-top:-6.3px;left:3.3351%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.7057%;margin-top:-13.8px;left:7.2244%;width:148px;">
      <p class="g-pstyle5"><span class="g-cstyle3">Po</span>n<span class="g-cstyle3">ti</span>fi<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a </span><span class="g-cstyle4">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">r</span>sid<span class="g-cstyle3">a</span>d<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle6">C<span class="g-cstyle4">a</span>t<span class="g-cstyle5">ó</span>l<span class="g-cstyle5">ic</span>a d<span class="g-cstyle5">e</span> R<span class="g-cstyle5">í</span>o <span class="g-cstyle5">de </span>Ja<span class="g-cstyle5">n</span>e<span class="g-cstyle5">i</span><span class="g-cstyle7">r</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1541%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle3">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1541%;margin-top:-7px;left:69.3932%;width:43px;">
      <p class="g-pstyle8">81,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.0039%;margin-top:-6.3px;left:3.3572%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.0762%;margin-top:-13.8px;left:7.5369%;width:128px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span>F<span class="g-cstyle3">e</span>de<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l </span></p>
      <p class="g-pstyle6">d<span class="g-cstyle5">e</span> R<span class="g-cstyle5">ío</span> <span class="g-cstyle5">G</span>r<span class="g-cstyle5">a</span>n<span class="g-cstyle5">d</span>e d<span class="g-cstyle5">el</span> Su<span class="g-cstyle5">r</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.923%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle3">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.923%;margin-top:-7px;left:69.0996%;width:45px;">
      <p class="g-pstyle8">8<span class="g-cstyle12">0</span><span class="g-cstyle13">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.7728%;margin-top:-6.3px;left:3.2903%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.2435%;margin-top:-13.8px;left:7.5369%;width:119px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span>F<span class="g-cstyle3">e</span>de<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l </span></p>
      <p class="g-pstyle6">d<span class="g-cstyle5">e</span> S<span class="g-cstyle5">ã</span>o Paul<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.4928%;margin-top:-7px;left:58.1145%;width:49px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle3">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.4928%;margin-top:-7px;left:69.2787%;width:44px;">
      <p class="g-pstyle8">8<span class="g-cstyle12">0</span><span class="g-cstyle14">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.3425%;margin-top:-6.3px;left:3.2903%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.614%;margin-top:-13.8px;left:7.5369%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>ad<span class="g-cstyle3"> </span>F<span class="g-cstyle3">e</span>de<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l</span></p>
      <p class="g-pstyle6">d<span class="g-cstyle5">e</span> R<span class="g-cstyle5">ío</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>Jan<span class="g-cstyle5">ei</span><span class="g-cstyle4">r</span><span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.0625%;margin-top:-7px;left:58.1145%;width:46px;">
      <p class="g-pstyle10"><span class="g-cstyle3">B</span>ra<span class="g-cstyle3">s</span>i<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.0625%;margin-top:-7px;left:69.189%;width:42px;">
      <p class="g-pstyle8">8<span class="g-cstyle12">0</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.9122%;margin-top:-6.3px;left:2.5237%;width:32px;">
      <p class="g-pstyle9"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.4837%;margin-top:-8.3px;left:3.3737%;width:248px;">
      <p class="g-pstyle11">(*) <span class="g-cstyle11">F</span>u<span class="g-cstyle5">en</span>te: ww<span class="g-cstyle15">w</span><span class="g-cstyle16">.</span>t<span class="g-cstyle5">i</span>mesh<span class="g-cstyle5">i</span>gh<span class="g-cstyle5">e</span><span class="g-cstyle4">r</span>e<span class="g-cstyle5">d</span>uc<span class="g-cstyle7">a</span>t<span class="g-cstyle5">i</span>o<span class="g-cstyle5">n.co</span>m<span class="g-cstyle1"> </span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-08-the-latam-box'
const namespace = 'g-'
const name = '08-the-latam'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 04:06 */
